/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable array-callback-return */
import countriesOptions from '@/mixins/countriesOptions';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import statesOptions from '@/mixins/statesOptions';
import streetTypesOptions from '@/mixins/streetTypesOptions';
import Validations from '@/mixins/validations';
import DraftData from '@/components/draft-data';

export default {
    /**
     * Nombre del componente
     */
    name: 'FiscalData',

    components: {
        DraftData
    },

    mixins: [countriesOptions, statesOptions, streetTypesOptions, formatData, keyed, Validations],

    /**
     * Datos del componente
     * @return {Object} Data del componente
     */
    data() {
        return {
            keyUpdate: 0,
            collapsed: false,
            fiscalAddressEdit: false,
            formatDataRules: () => ({
                f_address_key_state: ['state', (value, obj) => Object.assign({}, { key: value }, obj['state'])],
                f_address_state: ['state', (value, obj) => Object.assign({}, { name: value }, obj['state'])],
                f_address_key_country: [
                    'country',
                    value => (value ? { key: value, name: this.$t(`countries.${value}`) } : null)
                ],
                f_address_street_1: ['street_1', value => value],
                f_address_street_2: ['street_2', value => value],
                f_address_number: ['number', value => value],
                f_address_floor: ['floor', value => value],
                f_address_door: ['door', value => value],
                f_address_city: ['city', value => value],
                f_address_postal_code: ['postal_code', value => value]
            }),
            address: '',
            selectedAddress: ''
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        },
        data: {
            type: Object,
            required: false
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        hideActions: {
            type: Boolean,
            required: false,
            default: false
        },
        isModal: {
            type: Boolean,
            required: false,
            default: false
        },
        isContributor: {
            type: Boolean,
            required: false,
            default: false
        },
        intervenerStatus: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        // Google Maps Autocomplete function
        async getAddressData(addressData, placeResultData) {
            this.address = addressData;
            const completeAddress = placeResultData.address_components.reverse();
            let state;
            // Clear fields
            this.formattedData.street_1 = undefined;
            this.formattedData.number = undefined;
            this.formattedData.floor = undefined;
            this.formattedData.door = undefined;
            this.formattedData.street_2 = undefined;
            this.formattedData.postal_code = undefined;
            this.formattedData.country = undefined;
            this.formattedData.state = undefined;
            this.formattedData.city = undefined;
            // Assign search result to form fields
            completeAddress.map(ad => {
                if (ad.types.includes('route')) {
                    this.modifiedData['f_address_street_1'] = ad.long_name;
                    this.formattedData.street_1 = ad.long_name;
                }
                if (ad.types.includes('street_number')) {
                    this.modifiedData['f_address_number'] = ad.long_name;
                    this.formattedData.number = ad.long_name;
                }
                if (ad.types.includes('postal_code')) {
                    this.modifiedData['f_address_postal_code'] = ad.long_name;
                    this.formattedData.postal_code = ad.long_name;
                }
                if (ad.types.includes('locality') || ad.types.includes('postal_town')) {
                    this.modifiedData['f_address_city'] = ad.long_name;
                    this.formattedData.city = ad.long_name;
                }
                if (ad.types.includes('country')) {
                    if (ad.long_name === 'Spain') {
                        ad.long_name = 'España';
                    }
                    this.countriesOptions.map(co => {
                        if (co.name.includes(ad.long_name)) {
                            this.modifiedData['f_address_state'] = undefined;
                            this.modifiedData['f_address_key_state'] = undefined;
                            this.modifiedData['f_address_key_country'] = co.key;
                            this.formattedData.country = co;
                        }
                    });
                }
                if (ad.types.includes('administrative_area_level_2')) {
                    state = { key: ad.short_name, name: ad.long_name };
                } else if (
                    state === undefined &&
                    (ad.types.includes('administrative_area_level_1') || ad.types.includes('neighborhood'))
                ) {
                    state = { key: ad.short_name, name: ad.long_name };
                } else if (state === undefined && ad.types.includes('postal_town')) {
                    state = { key: ad.short_name, name: ad.long_name };
                }
            });
            await this.loadStatesOptions(this.formattedData.country.key);
            if (state !== undefined) {
                this.statesOptions.map(po => {
                    if (po.name.includes(state.name)) {
                        this.modifiedData['f_address_state'] = po.name;
                        this.modifiedData['f_address_key_state'] = po.key;
                        this.formattedData.state = po;
                        this.keyUpdate++;
                    }
                });
            }
        },
        /**
         * @param {Boolean} edit allow edit or not
         * @param {Event} e Evento del form
         */
        editFiscalAddress(edit, e) {
            e.preventDefault();
            e.stopPropagation();
            this.fiscalAddressEdit = edit;
            if (edit) {
                // Si la provincia viene como texto migrado que no casa con el listado,
                // el find devuelve undefined y el desplegable queda sin selección (correcto:
                // obliga a elegir una válida). El guard evita leer .key/.name sobre undefined,
                // que era lo que reventaba al cancelar (state ya era undefined del edit previo).
                if (this.formattedData.state) {
                    const stateKey = this.formattedData.state.key || this.formattedData.state.name;
                    this.formattedData.state = this.statesOptions.find(item => item.key === stateKey);
                }
                if (!this.collapsed) {
                    this.$root.$emit('bv::toggle::collapse', 'collapse-fiscal-address');
                }
            }
            if (!edit) {
                this.formatData();
                this.modifiedData = {};
            }
        },

        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            switch (field) {
                case 'street_1':
                    this.modifiedData['f_address_street_1'] = val;
                    break;
                case 'street_2':
                    this.modifiedData['f_address_street_2'] = val;
                    break;
                case 'number':
                    this.modifiedData['f_address_number'] = val;
                    break;
                case 'floor':
                    this.modifiedData['f_address_floor'] = val;
                    break;
                case 'door':
                    this.modifiedData['f_address_door'] = val;
                    break;
                case 'city':
                    this.modifiedData['f_address_city'] = val;
                    break;
                case 'postal_code':
                    this.modifiedData['f_address_postal_code'] = val;
                    break;
                case 'state':
                    if (typeof val === 'object' && val !== null) {
                        this.modifiedData['f_address_state'] = val.name;
                        this.modifiedData['f_address_key_state'] = val.key;
                    } else {
                        this.modifiedData['f_address_state'] = val;
                    }
                    break;
                case 'key_country':
                    if (this.formattedData.state) {
                        this.formattedData.state = undefined;
                    }
                    this.modifiedData['f_address_key_country'] = val.key;
                    this.modifiedData['f_address_state'] = undefined;
                    this.modifiedData['f_address_key_state'] = undefined;
                    this.loadStatesOptions(val.key);
                    break;
                default:
                    this.modifiedData[field] = typeof val === 'object' ? val.key : val;
                    break;
            }
            this.keyUpdate++;
            this.$emit(`${field}-changed`, val);
        },

        /**
         * @param {Event} e FormEvent
         */
        submitAddress(e) {
            e.preventDefault();
            this.validateData().then(valid => {
                if (!valid) {
                    return;
                }
                this.$intervenersService.updateIntervenerInfo(this.uuid, this.modifiedData)
                    .then(res => {
                        this.$toast.success(res.result.http_code, res.result.info);
                        this.fiscalAddressEdit = false;
                        this.$root.$emit('refresh_intervener');
                    })
                    .catch(err => {
                        console.error(err);
                        this.$toast.error(err.name, err.message);
                        this.modifiedData = {};
                        this.fiscalAddressEdit = false;
                    });
            });
        },

        /**
         * Al cancelar la edición se cierra el desplegable
         * @param {*} e Event
         */
        cancelAddress(e) {
            this.editFiscalAddress(false, e);
        },

        /**
         * @override
         */
        getData() {
            return Object.assign({}, this.data, this.modifiedData);
        },

        /**
         * Comprueba que se ha seleccionado un dirección fiscal
         * @return {*} validacion
         */
        validateData() {
            this.cleanErrors();
          
            // Define las propiedades requeridas si las tienes; por ahora usamos un stub
            const requiredProperties = ['street_1', 'postal_code', 'country', 'state', 'city' ];
          
            return Promise.resolve(true)
              .then(valid => this.validateRequired(requiredProperties, valid));
        } 
          
    },

    /**
     * @override
     */
    async beforeMount() {
        this.fiscalAddressEdit = this.creation && !this.existing;
        this.collapsed = true;

        if (this.data && this.data.f_address_key_country) {
            await this.loadStatesOptions(this.data.f_address_key_country);
        }
    }
};
